var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},_vm._l((_vm.letters),function(item){return _c('li',{key:item,ref:item,refInFor:true,staticClass:"item",on:{"click":_vm.handleClick,"touchstart":function($event){$event.preventDefault();return _vm.handleTouchStart($event)},"touchmove":_vm.handleTouchMove,"touchend":_vm.handleTouchEnd}},[_vm._v(_vm._s(item))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15922b60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/city/components/Alphabet.vue
// module id = null
// module chunks = 